//Modules
import React from "react"
import { graphql } from "gatsby"
//Components
import Layout from "../../components/Layout/Layout"
import SEO from "../../components/SEO/SEO"
import ClassroomManagement from "../../components/ClassroomManagement/ClassroomManagement"

const RoutinesAndProceduresPage = ({ data }) => {
  const classroomManagement = data.classroomManagement

  return (
    <Layout>
      <SEO title="Classroom Management" description="Classroom Management" />
      <ClassroomManagement section={classroomManagement} />
    </Layout>
  )
}

export const query = graphql`
  {
    classroomManagement: contentfulClassroomManagement(
      name: { eq: "Routines & Procedures" }
    ) {
      name
      body {
        json
      }
    }
  }
`

export default RoutinesAndProceduresPage
